import { useAuthStore } from "../stores/auth-store";

export function useCompanyId() {
  return useAuthStore((s) => s.currentCompanyId);
}
